@if (trackingData(); as data) {
  <div class="content-section mx-auto p-6 min-h-screen">
    <div class="flex items-center justify-between mb-6">
      <h1 class="text-3xl font-semibold text-gray-900 flex items-center gap-2">
        <sham-i-arrow-line-left class="md:hidden" (click)="goToBack()" />
        <span class="hidden md:flex">{{ 'order' | translate }}</span>
        {{ data.orderNumber }}
      </h1>
      <button
        (click)="openCreateModal()"
        class="p-3 rounded-lg bg-[#EA708A] flex items-center gap-2 text-white-light! hover:text-white-darkest! text-xl hover:bg-gray-200 transition"
      >
        <sham-i-customer-service-01 />
      </button>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 items-start">
      <!--row1 -->

      <div
        class="order-1 lg:order-0 lg:col-span-2 border border-gray-200 rounded-lg p-2 md:p-6"
      >
        <!-- Title -->
        <h2 class="text-[20px] font-semibold text-[#2B2B2B] mb-10">
          {{ 'order_progress' | translate }}
        </h2>

        <div class="relative">
          @if (!isCancelled()) {
            <!-- Main Gray Line -->
            <div
              class="absolute top-4 md:top-5 left-6 right-6 md:left-12 md:right-12 h-0.5 bg-[#D9D9D9]"
            ></div>

            <!-- Active Blue Line -->
            <div
              class="absolute top-4 md:top-5 left-0 h-0.5 bg-[#2187AB] transition-all duration-300"
              [style.width.%]="progress"
            ></div>
            <!-- Steps -->
            <div
              class="relative flex justify-between items-start z-10 gap-2 md:gap-0"
            >
              @for (step of steps(); track step.label) {
                <div
                  class="flex flex-col items-center relative z-10 bg-[#ffffff] max-w-15 md:max-w-25 flex-1"
                >
                  <!-- ICON -->
                  <div
                    class="relative z-10 bg-[#ffffff] flex items-center justify-center bottom-3"
                  >
                    @switch (step.icon) {
                      @case ('truck') {
                        <sham-i-Truck
                          class="*:size-7"
                          [ngClass]="
                            step.completed ? 'text-[#2187AB]' : 'text-[#9E9E9E]'
                          "
                        />
                      }

                      @case ('checkmark') {
                        <div
                          class="rounded-full p-0.3"
                          [ngClass]="step.completed ? 'bg-[#2187AB]' : 'bg-[#9E9E9E]'"
                        >
                          <sham-i-tick-01 class="*:size-6 text-[#ffffff]" />
                        </div>
                      }

                      @case ('invoice') {
                        <sham-i-package
                          class="*:size-6"
                          [ngClass]="
                            step.completed ? 'text-[#2187AB]' : 'text-[#9E9E9E]'
                          "
                        />
                      }

                      @case ('package') {
                        <sham-i-package-delivered
                          class="*:size-6"
                          [ngClass]="
                            step.completed ? 'text-[#2187AB]' : 'text-[#9E9E9E]'
                          "
                        />
                      }
                    }
                  </div>

                  <!-- TEXT -->
                  <div class="mt-3 text-center bg-[#ffffff] relative z-10">
                    <div
                      class="text-xs md:text-sm font-medium leading-tight text-center"
                      [ngClass]="step.completed ? 'text-[#2187AB]' : 'text-[#9E9E9E]'"
                    >
                      {{ step.label | translate }}
                    </div>

                    <div
                      class="text-[10px] md:text-[14px] text-[#8B8B8B] mt-1 md:mt-2 leading-tight text-center"
                    >
                      {{ step.date }}
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          @if (isCancelled()) {
            <div class="flex flex-col items-center justify-center text-center">
              <sham-i-package class="*:size-14 text-[#FF383CE5]" />

              <p class="mt-3 text-[#FF383CE5] font-semibold text-lg">
                {{ 'order_cancelled' | translate }}
              </p>
            </div>
          }
        </div>
      </div>

      <!-- map -->
      <div class="order-3 lg:order-0 rounded-lg overflow-hidden">
        <img src="assets/images/map.png" class="w-full h-full object-cover" />
      </div>

      <!--  row 2 -->

      <!-- order items -->
      <div class="order-2 lg:order-0 lg:col-span-2">
        <div class="border-0 md:border md:border-gray-200 rounded-lg p-0 md:p-6">
          <h2 class="text-sm font-semibold mb-4 md:hidden">
            {{ 'items_in_your_order' | translate }}
          </h2>
          <!-- @for (sellerOrder of storeOrders(); track $index; let firstStore = $first) { -->
          <div class="border border-[#E6E6E6] rounded-xl p-4 md:p-0 md:border-0 mt-4">
            <div
              class="hidden md:flex flex-col md:flex-row md:items-center md:justify-between border-b border-[#E6E6E6] pb-3 mb-4 gap-3"
            >
              <!-- product/store info -->
              <div class="flex items-center gap-3 order-2 md:order-1">
                <div
                  class="w-8 h-8 rounded-full bg-gray-100 overflow-hidden flex items-center justify-center border border-gray-200"
                >
                  <img
                    [src]="getImageUrl(data.sellerStoreLogoUrl)"
                    [alt]="data.sellerStoreName"
                    class="w-7 h-7 rounded-full"
                  />
                </div>

                <h2 class="text-sm font-medium text-[#114455]">
                  {{ data.sellerStoreName }}
                </h2>
              </div>

              <!-- tracking -->
              <a
                (click)="goToSellerProfile(data.sellerId)"
                class="flex items-center gap-2 text-xs font-medium text-[#114455] underline cursor-pointer order-1 md:order-2"
              >
                <!-- <sham-i-delivery-truck-1 /> -->
                <span class="underline"> {{ 'view_store' | translate }}</span>
              </a>
            </div>

            <div class="space-y-6">
              @for (item of data.items; track item.productId; let lastItem = $last) {
                <div
                  class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-[#E6E6E6] pb-6 mb-6"
                  [class.border-b-0]="lastItem"
                  [class.mb-0!]="lastItem"
                  [class.pb-0!]="lastItem"
                >
                  <div class="flex gap-4 flex-1">
                    <div
                      class="w-25 h-25 border border-[#E6E6E6] rounded-md overflow-hidden p-2 flex items-center justify-center shrink-0"
                    >
                      <img
                        [src]="getImageUrl(item.productImageUrl)"
                        [alt]="item.productName"
                        class="max-w-full max-h-full object-contain"
                      />
                    </div>

                    <div class="flex flex-col justify-between py-1 flex-1">
                      <div>
                        <h3 class="text-base font-semibold">
                          {{ item.productName }}
                        </h3>

                        <p class="text-sm text-[#424654] font-normal">
                          {{ getOptionsText(item.options) }}
                        </p>
                      </div>

                      <div class="flex items-center justify-between gap-4 pt-1">
                        <span
                          class="inline-block bg-[#DAE2FF] text-[#0040A1] font-medium text-sm px-2 py-1 rounded"
                        >
                          {{ 'qty' | translate }}: {{ item.quantity }}
                        </span>

                        <span class="text-base font-semibold">
                          {{ data.summary.currencyCode }} {{ item.subTotal }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="mt-4 flex justify-between items-center gap-3 md:hidden">
                <!-- store name -->
                <div class="flex items-center gap-3">
                  <div
                    class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center border"
                  >
                    <span class="text-xs font-bold text-gray-600">
                      <!-- {{ store.storeName.substring(0, 2) }} -->
                    </span>
                  </div>

                  <h2 class="text-sm font-medium text-[#114455]">
                    {{ data.sellerStoreName }}
                  </h2>
                </div>

                <!-- track order -->
                <a
                  (click)="goToSellerProfile(data.sellerId)"
                  class="flex items-center gap-2 text-xs font-medium text-[#114455] underline cursor-pointer order-1 md:order-2"
                >
                  <!-- <sham-i-delivery-truck-1 /> -->
                  <span class="underline">
                    {{ 'items_in_your_order' | translate }}</span
                  >
                </a>
              </div>
            </div>
          </div>
          <!-- } -->
        </div>

        <div class="pt-4 hidden md:block">
          <button
            (click)="goBack()"
            class="px-5 py-2.5 rounded-lg bg-[#F2F2F2] flex items-center gap-2 text-white-darkest text-xl hover:text-black hover:bg-gray-200 transition"
          >
            {{ 'Return to store' | translate }}
          </button>
        </div>
      </div>
      <div class="space-y-6 order-4 lg:order-0">
        <!-- shipping -->
        <div class="border border-gray-100 rounded-lg p-6 space-y-8 shadow-sm">
          <section class="mb-4">
            <div class="flex items-center gap-1 text-[#2187AB] mb-4">
              <sham-i-location-address />
              <h3 class="text-sm font-semibold uppercase tracking-widest">
                {{ 'shipping_to' | translate }}
              </h3>
            </div>

            <p class="font-bold text-sm">{{ data.shippingAddress.fullName }}</p>
            <p>
              {{ data.shippingAddress.streetAddress }},
              {{ data.shippingAddress.city }}, {{ data.shippingAddress.country }}
            </p>
          </section>

          <hr class="mb-4" />
          <section class="mb-0 mt-2">
            <div class="flex items-center gap-2 text-[#2187AB] mb-4">
              <sham-i-payment-success-01 />
              <h3 class="text-sm font-semibold uppercase tracking-widest">
                {{ 'payment_method' | translate }}
              </h3>
            </div>
            <div class="flex items-center gap-3">
              <div>
                <p class="text-sm font-semibold text-gray-900">
                  {{ data.paymentMethod | translate }}
                </p>
                <!-- <p class="text-xs text-[#424654] font-normal mt-1">Transaction ID: TX-90221</p> -->
              </div>
            </div>
          </section>
        </div>

        @if (data.appliedCoupon) {
          <article
            class="flex border border-gray-100 rounded-xl overflow-hidden shadow-sm transition-all duration-300 group h-28 w-full"
          >
            <!-- Left Edge - Generic style (category system removed per Open Question #1) -->
            <div
              class="relative w-14 flex items-center justify-center transition-colors bg-[#E5F1F6] text-[#4194A6]"
              style="
                -webkit-mask-image: radial-gradient(
                  circle at 0px 50%,
                  transparent 12px,
                  black 12.5px
                );
                mask-image: radial-gradient(
                  circle at 0px 50%,
                  transparent 12px,
                  black 12.5px
                );
                -webkit-mask-size: 100% 36px;
                mask-size: 100% 36px;
                mask-repeat: repeat-y;
                filter: drop-shadow(2px 0px 3px rgba(0, 0, 0, 0.15));
              "
            >
              <span
                class="transform -rotate-90 tracking-[0.2em] text-2xs sm:text-xs font-bold uppercase whitespace-nowrap select-none pl-2"
              >
                {{ 'coupon' | translate }}
              </span>
            </div>

            <!-- Middle Content: Details -->
            <div class="flex-1 py-3 px-4 flex flex-col justify-center">
              <h3
                class="font-bold text-gray-900 text-sm sm:text-base group-hover:text-[#2899BB] transition-colors truncate"
              >
                {{ data.appliedCoupon.code }}
              </h3>
              <p class="text-gray-500 text-xs mt-1 sm:text-sm line-clamp-2">
                {{ data.appliedCoupon.discountValue }}%
              </p>
            </div>

            <!-- Right Action: Code & Button -->
            <div
              class="w-28 sm:w-36 py-3 px-3 flex flex-col items-center justify-center gap-y-2 border-l border-dashed border-gray-200"
            >
              <span
                class="font-bold text-gray-800 text-xs sm:text-sm text-center w-full"
              >
                {{ data.appliedCoupon.title }}
              </span>
            </div>
          </article>
        }

        <!-- summary -->
        <div
          class="bg-linear-to-b from-[#66B2CD] to-[#187799] rounded-lg p-6 text-white"
        >
          <h3 class="font-bold text-lg text-[#FFFFFF] mb-4">
            {{ 'summary' | translate }}
          </h3>
          <div class="space-y-4 font-normal text-sm text-white">
            <div class="flex justify-between">
              <span>{{ 'subtotal' | translate }}</span
              ><span>
                {{ data.summary.currencyCode }}
                {{ data.summary.subTotal }}
              </span>
            </div>
            <div class="flex justify-between border-b border-white/20 pb-4">
              <span>{{ 'shipping' | translate }}</span
              ><span
                >{{ data.summary.currencyCode }} {{ data.summary.shippingCost }}
              </span>
            </div>
            <div class="flex justify-between">
              <span>{{ 'taxes_estimated' | translate }}</span
              ><span>{{ data.summary.currencyCode }} 0</span>
            </div>

            <div class="flex justify-between border-b border-[#FFFFFF33] pb-4">
              <span>{{ 'totalDiscount' | translate }}</span
              ><span
                >{{ data.summary.currencyCode }}
                {{ data.summary.couponDiscountAmount }}
              </span>
            </div>

            <div class="flex justify-between text-xl font-semibold text-[#FFFFFF]">
              <span>{{ 'total' | translate }}</span>
              <span>{{ data.summary.currencyCode }} {{ data.summary.total }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (isCreateModalOpen()) {
      <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="create-ticket-title"
      >
        <section class="w-full max-w-123 rounded-lg bg-white px-7 py-7 shadow-xl">
          <div
            class="flex items-center justify-between border-b border-[#E6E6E6] pb-4"
          >
            <div class="flex items-center gap-3">
              <sham-i-ticket-01-blue />
              <div>
                <h2
                  id="create-ticket-title"
                  class="text-2xl font-bold text-[#254456]"
                >
                  Create Ticket
                </h2>
                <p class="mt-1 text-sm font-medium text-[#8D95A3]">
                  {{ data.sellerOrderNumber || data.orderNumber }}
                </p>
              </div>
            </div>
            <button
              type="button"
              class="text-3xl font-light leading-none text-[#6D6D6D] disabled:opacity-50"
              aria-label="Close modal"
              [disabled]="isCreating()"
              (click)="closeCreateModal()"
            >
              x
            </button>
          </div>

          <div class="mt-8 space-y-5">
            <label class="block">
              <span class="mb-2 block text-base font-semibold text-[#111111]">
                Reason
              </span>
              <select
                class="h-12 w-full rounded-lg border border-[#D5D8DE] px-4 text-base text-[#8D95A3] outline-none focus:border-[#2187AB]"
                [value]="ticketForm().reason"
                (change)="updateTicketForm('reason', $any($event.target).value)"
              >
                <option value="">Select Reason</option>
                @for (reason of reasonOptions(); track reason.id) {
                  <option [value]="reason.id">{{ reason.name }}</option>
                }
              </select>
            </label>

            @if (ticketForm().reason === 'Other') {
              <label class="block">
                <span class="mb-2 block text-base font-semibold text-[#111111]">
                  Custom Reason
                </span>
                <input
                  class="h-12 w-full rounded-lg border border-[#D5D8DE] px-4 text-base outline-none focus:border-[#2187AB]"
                  placeholder="Custom reason"
                  [value]="ticketForm().customReason"
                  (input)="
                    updateTicketForm('customReason', $any($event.target).value)
                  "
                />
              </label>
            }

            <label class="block">
              <span class="mb-2 block text-base font-semibold text-[#111111]">
                Description
              </span>
              <textarea
                class="h-24 w-full resize-none rounded-lg border border-[#D5D8DE] px-4 py-3 text-base outline-none focus:border-[#2187AB]"
                placeholder="Description"
                [value]="ticketForm().description"
                (input)="updateTicketForm('description', $any($event.target).value)"
              ></textarea>
            </label>
          </div>

          @if (createError()) {
            <p class="mt-3 text-sm text-red-600">{{ createError() }}</p>
          }

          <div class="mt-6 grid grid-cols-1 gap-8 sm:grid-cols-2">
            <button
              type="button"
              class="h-10 rounded-lg border border-[#D5D8DE] text-lg font-normal text-[#4B4B4B] disabled:opacity-50"
              [disabled]="isCreating()"
              (click)="closeCreateModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="h-10 rounded-lg bg-[#2187AB] text-lg font-normal text-white disabled:opacity-60"
              [disabled]="isCreating()"
              (click)="createTicket()"
            >
              {{ isCreating() ? 'Sending...' : 'Send' }}
            </button>
          </div>
        </section>
      </div>
    }

    @if (isSuccessModalOpen()) {
      <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ticket-created-title"
      >
        <section
          class="w-full max-w-[492px] rounded-lg bg-[#fff] px-6 pb-8 text-center shadow-xl"
        >
          <div class="mx-auto mb-6 mt-12 flex justify-center text-[#2187AB]">
            <img src="assets/images/Done.svg" alt="done-image" class="" />
          </div>

          <h2
            id="ticket-created-title"
            class="text-2xl font-semibold leading-8 text-[#0D3543]"
          >
            Ticket Created Successfully
          </h2>
          <p class="my-3 text-base text-[#6C737F]">
            Our team will review it and respond shortly
          </p>

          <div class="mt-6 grid grid-cols-1 gap-9 sm:grid-cols-2">
            <button
              type="button"
              class="h-8 rounded-lg border border-[#D5D8DE] text-base font-normal text-[#4B4B4B]"
              (click)="closeSuccessModal()"
            >
              Back To Order
            </button>
            <a
              class="flex h-8 items-center justify-center rounded-lg bg-[#2187AB] text-base font-normal text-white"
              [routerLink]="['/ticket-details', createdTicket()?.id]"
              (click)="closeSuccessModal()"
            >
              View Ticket Details
            </a>
          </div>
        </section>
      </div>
    }
  </div>
}
